import {initInputStateSwitch} from "./input.state-switch";
import {initGetAjaxForm} from "./.get-ajax-form";
import {initAHrefLightbox} from "./a[href*='#lightbox']";
import {initYagaLinks} from './[data-click-yaga]';
import {initYagaButtons} from './[data-yaga]';
import {initRange} from "./div.range";
import {initShare} from "./div.share";
import {initCopyButton} from './[data-copy]';
import {smoothScrool} from './scrollDown';
import {initBlitz} from './divBlitz';

export const initElements = () => {
	initInputStateSwitch();
	initGetAjaxForm();
	initAHrefLightbox();
	initYagaLinks();
	initYagaButtons();
	initRange();
	initShare();
	initCopyButton();
	smoothScrool();
	initBlitz();
};
